/**
 * Forge Vision embed — wraps the ForgeVisionExperience in a bare shell
 * for iframe hosting on the marketing site.
 */
import React from "react";
import EmbedShell from "@/pages/embed/EmbedShell";
import { ForgeVisionExperience } from "@/pages/tools/ForgeVisionExperience";

export default function ForgeVisionEmbed() {
    return (
        <EmbedShell kind="forge_vision">
            <ForgeVisionExperience />
        </EmbedShell>
    );
}
